exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar .navbar-nav li.menu-item-has-children.show>a,.navbar .navbar-nav li.menu-item-has-children.show>a i.menu-icon,.navbar .navbar-nav li.menu-item-has-children.show>ul.sub-menu li.nav-item>a i.menu-icon .navbar .navbar-nav li.menu-item-has-children.show>ul.sub-menu li.nav-item>a .menu-title-text,.navbar .navbar-nav li>a.active,.navbar .navbar-nav li>a.active>i.menu-icon,.navbar .navbar-nav li>a.open,.navbar .navbar-nav li>a.open>i.menu-icon{color:#fff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14abe57b","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sidebar/SidebarNavItem.vue
// module id = 650
// module chunks = 27